module.exports = __webpack_public_path__ + "932f17b9fbb601d598b4344d7dac0d9e.MP3";